import { render, staticRenderFns } from "./ApplePlayBtnExp.vue?vue&type=template&id=12190b2a&scoped=true"
import script from "./ApplePlayBtnExp.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApplePlayBtnExp.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ApplePlayBtnExp.vue?vue&type=style&index=0&id=12190b2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12190b2a",
  null
  
)

export default component.exports